// ANX-077 — разбивка текста сообщения на сегменты с пометкой совпадений
// для подсветки результатов in-conversation поиска. Pure-функция ради
// юнит-тестируемости (используется в MessageRow).

export interface HighlightPart {
  text: string;
  match: boolean;
}

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * highlightParts — делит `text` на последовательность сегментов, помечая
 * те, что совпадают с любым из термов `query` (разделённых пробелами,
 * регистронезависимо). Соседние сегменты не схлопываются — порядок и
 * содержимое сохраняются (конкатенация .text === исходный text).
 */
export function highlightParts(text: string, query: string): HighlightPart[] {
  if (text === '') return [];
  const terms = query.trim().split(/\s+/).filter(Boolean);
  if (terms.length === 0) return [{ text, match: false }];

  const re = new RegExp('(' + terms.map(escapeRegExp).join('|') + ')', 'gi');
  const out: HighlightPart[] = [];
  let last = 0;
  for (const m of text.matchAll(re)) {
    const idx = m.index ?? 0;
    if (idx > last) out.push({ text: text.slice(last, idx), match: false });
    out.push({ text: m[0], match: true });
    last = idx + m[0].length;
  }
  if (last < text.length) out.push({ text: text.slice(last), match: false });
  return out;
}
